



import LivePdfComponent from "@/components/admin/live/livePdfComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LivePdfPage",
  components: {
    LivePdfComponent,
  },
})
export default class LivePdfPage extends Vue {}
